import React from "react";
import { leftRightContextType } from "../leftRightContextHook";

type directionType = "left" | "right";
interface shiftButtonProps {
  direction: directionType;
  onClick: (_: directionType) => void;
  context: leftRightContextType;
}
const ShiftButton: React.FC<shiftButtonProps> = (props) => {
  let content;
  if (props.direction === "right") {

  } else {

  }
  
  return (
    <div className={`shift-buttons flex ${props.direction}`} onClick={() => props.onClick(props.direction)}>
      {content}
    </div>
  );
};
export default ShiftButton;
